var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaperPlaneRainbow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.9599 16.9547C70.2475 15.6158 68.9349 14.4869 67.6544 14.9755L12.112 36.1784C11.4435 36.4336 11.0014 37.0743 11 37.7898C10.9986 38.5054 11.4382 39.1478 12.1058 39.4056L27.7087 45.4317V64.4121C27.7087 65.2128 28.2585 65.9086 29.0375 66.0937C29.8113 66.2778 30.6181 65.9096 30.9809 65.19L37.434 52.3843L53.1823 64.0716C54.1402 64.7826 55.5171 64.3304 55.8657 63.1879C70.5694 14.9793 69.9337 17.0758 69.9599 16.9547ZM56.2493 23.0296L29.1922 42.2988L17.5504 37.8026L56.2493 23.0296ZM31.1657 45.1373L54.7503 28.3413C34.4561 49.7504 35.516 48.6236 35.4275 48.7427C35.296 48.9196 35.6562 48.2302 31.1657 57.1412V45.1373ZM53.2741 59.8348L39.412 49.5473L64.4765 23.1056L53.2741 59.8348Z",
    fill: "url(#paint0_linear_7425_11761)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7425_11761",
    x1: 69.9999,
    y1: 51.7178,
    x2: 11,
    y2: 51.7178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5ABF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#6C5CE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989583,
    stopColor: "#42B2FC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperPlaneRainbow);
export default __webpack_public_path__ + "static/media/paper-plane-rainbow.9bcd2c642519908a290b157f87dffae2.svg";
export { ForwardRef as ReactComponent };